import React from "react";
import "../organisationCard.css";
import { Organisation } from "../../../features/organisation/organisationTypes";
import OrganisationServiceTypeInfo from "../organisationServiceTypeInfo";
import OrganisationModalAdditionalInfo from "./organisationModalAdditionalInfo";
import OrganisationContactInfo from "../organisationContactInfo";
import { ColumnFlexBox, RowFlexBox } from "../../common/FlexBoxes";
import { ParagraphSmall } from "@tal-gel/components-v2";

interface propsFromComponent {
  item: Organisation;
}

type Props = propsFromComponent;

const OrganisationModal: React.FC<Props> = ({ item }) => {
  return (
    <ColumnFlexBox style={{ alignItems: "flex-start", gap: "16px" }}>
      <ParagraphSmall>{item.description}</ParagraphSmall>
      <ColumnFlexBox style={{ width: 700, alignItems: "flex-start" }}>
        <RowFlexBox style={{ width: "100%" }}>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
            <OrganisationContactInfo item={item} />
          </div>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
            <OrganisationModalAdditionalInfo item={item} />
          </div>
        </RowFlexBox>
        <OrganisationServiceTypeInfo item={item} />
      </ColumnFlexBox>
    </ColumnFlexBox>
  );
};

export default OrganisationModal;
